import { useQuery } from '@tanstack/react-query';
import { fetchGallery } from '../../services/gallery';
import { GalleryContext } from '../../types/gallery';

export const galleryQueryKey = (context: GalleryContext | null) => [
  'gallery',
  context,
];

function useGetGallery(context: GalleryContext | null) {
  const { data, isLoading, isError, isSuccess, refetch } = useQuery({
    queryKey: galleryQueryKey(context),
    queryFn: () => fetchGallery(context as GalleryContext),
    enabled: !!context,
  });

  return { images: data, isLoading, isError, isSuccess, refetch };
}

export default useGetGallery;
